
/* SHIPPING_RATE */
export const GET_SHIPPING_RATE_LISTING = "GET_SHIPPING_RATE_LISTING";
export const GET_SHIPPING_RATE_LISTING_SUCCESS = "GET_SHIPPING_RATE_LISTING_SUCCESS";
export const GET_SHIPPING_RATE_LISTING_FAIL = "GET_SHIPPING_RATE_LISTING_FAIL";

export const GET_SHIPPING_RATE_DETAILS = "GET_SHIPPING_RATE_DETAILS";
export const GET_SHIPPING_RATE_DETAILS_SUCCESS = "GET_SHIPPING_RATE_DETAILS_SUCCESS";
export const GET_SHIPPING_RATE_DETAILS_FAIL = "GET_SHIPPING_RATE_DETAILS_FAIL";

export const ADD_SHIPPING_RATE = "ADD_SHIPPING_RATE";
export const ADD_SHIPPING_RATE_SUCCESS = "ADD_SHIPPING_RATE_SUCCESS";
export const ADD_SHIPPING_RATE_FAIL = "ADD_SHIPPING_RATE_FAIL";

export const UPDATE_SHIPPING_RATE = "UPDATE_SHIPPING_RATE";
export const UPDATE_SHIPPING_RATE_SUCCESS = "UPDATE_SHIPPING_RATE_SUCCESS";
export const UPDATE_SHIPPING_RATE_FAIL = "UPDATE_SHIPPING_RATE_FAIL";

export const DELETE_SHIPPING_RATE = "DELETE_SHIPPING_RATE";
export const DELETE_SHIPPING_RATE_SUCCESS = "DELETE_SHIPPING_RATE_SUCCESS";
export const DELETE_SHIPPING_RATE_FAIL = "DELETE_SHIPPING_RATE_FAIL";

export const EXPORT_SHIPPING_RATE = "EXPORT_SHIPPING_RATE";
export const EXPORT_SHIPPING_RATE_SUCCESS = "EXPORT_SHIPPING_RATE_SUCCESS";
export const EXPORT_SHIPPING_RATE_FAIL = "EXPORT_SHIPPING_RATE_FAIL";

export const RESET_SHIPPING_RATE_STATE = 'RESET_SHIPPING_RATE_STATE';
export const RESET_SHIPPING_RATE_ATTACHMENT_STATE = 'RESET_SHIPPING_RATE_ATTACHMENT_STATE';